import CreatorsList from 'app/(singles)/CreatorsList';
import Layout from '../layout';
import SingleHeader from 'components/UI/Single/SingleHeader';

const CreatorsListPage = () => {
  return (
    <Layout content={<CreatorsList />}>
      <header className="relative py-10 z-10 md:py-14 lg:py-20 bg-neutral-900 dark:bg-black">
        {/* SINGLE HEADER */}
        <div className="dark container relative z-10">
          <div className="max-w-screen-lg">
            <SingleHeader
              title="Are you wanting content creating? If so, see our list of vetted, recommended content creators, who can help!"
              tagName="Creator Directory"
              href="/creators"
              date="08/13/2024"
            />
          </div>
        </div>
      </header>
    </Layout>
  );
};

export default CreatorsListPage;
